import React from "react";
import { Container } from "@material-ui/core";
import { useParams } from "react-router-dom";
import { useStyles } from "./styles";
import { useEvento } from "./hooks/useEvento";
import { useEtapas } from "./hooks/useEtapas";
import TransparenciaSection from "../home/sections/Transparencia";
import CardEventoResultado from "./sections/CardEventoResultado";
import CardEventoCompeticao from "./sections/CardEventoCompeticao";
import AccordionCard from "./sections/AccordionCard";
import ResultadosSection from "./sections/ResultadosSection";
import CronogramaSection from "./sections/CronogramaSection";
import TabelaAtleta from "./sections/TabelaAtleta";
import EventoInfo from "./sections/EventoInfo";
import BoletinsEvento from "./sections/BoletinsEvento";
import NoticiasEvento from "./sections/NoticiasEvento";
import Galeria from "./sections/Galeria";
import InstagramSection from "../noticias/sections/Instagram";
import AcompanheTreinos from "../noticias/sections/AcompanheTreinos";
import SectionTitle from "../../components/SectionTitle";
import PageHead from "./sections/PageHead";

export default function PageCompeticaoItem({ resultado }) {
  const classes = useStyles();
  const { id } = useParams();

  // Data fetching
  const { evento } = useEvento({ idEvento: id });
  const { etapas } = useEtapas({ idEvento: id });

  // Component selection
  const CardEvento = resultado ? CardEventoResultado : CardEventoCompeticao;

  return (
    <React.Fragment>
      <PageHead evento={evento} />

      <div className={classes.root}>
        {/* Header Card */}
        <Container maxWidth="md">
          <CardEvento
            loading={evento.loading}
            evento={evento.payload}
            errorEvento={evento.error}
          />
        </Container>
        {/* Main Content */}
        <div className={classes.content}>
          <div className={classes.blurContainer}>
            {/* Primary Accordion: Results or Schedule */}
            <Container maxWidth="md">
              <div className={classes.firstCard}>
                <AccordionCard
                  resultado={resultado}
                  title={resultado ? "Resultado de Provas" : "Cronograma"}
                >
                  {resultado ? (
                    <ResultadosSection idEvento={id} etapas={etapas} />
                  ) : (
                    <CronogramaSection etapas={etapas} />
                  )}
                </AccordionCard>
              </div>
            </Container>

            {/* Detailed Results Table */}
            {resultado && evento.payload?.id && (
              <Container maxWidth="lg" className={classes.containerMD}>
                <section>
                  <TabelaAtleta idEvento={id} evento={evento.payload} />
                </section>
              </Container>
            )}

            {/* Event Info */}
            <Container maxWidth="md">
              <section>
                <EventoInfo
                  loading={evento.loading}
                  evento={evento.payload}
                  errorEvento={evento.error}
                  pageResultado={resultado}
                />
              </section>
            </Container>

            {/* Secondary Schedule (on results page) */}
            {resultado && (
              <Container maxWidth="md" className={classes.containerMD}>
                <AccordionCard resultado={false} title="Cronograma">
                  <CronogramaSection etapas={etapas} />
                </AccordionCard>
              </Container>
            )}

            {/* Additional Content */}
            <Container maxWidth="md">
              <BoletinsEvento idEvento={id} />
              <NoticiasEvento idEvento={id} />
              <Galeria idEvento={id} />
            </Container>

            {/* Instagram & Training Section */}
            <section className={classes.lastSection}>
              <InstagramSection noPaddintTop />
              <Container maxWidth="md">
                <SectionTitle color="infoLight">
                  Acompanhe os treinos da seleção:
                </SectionTitle>
                <AcompanheTreinos />
              </Container>
            </section>
          </div>
        </div>
      </div>
      <TransparenciaSection />
    </React.Fragment>
  );
}
